<template>
  <Layout>
    <div v-if="true" class="col-sm-12 mb-3">
      <div class="alert-cancelamento">
        <div class="alert-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="#b45309" stroke-width="1.5"/>
            <path d="M10 6v5" stroke="#b45309" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="10" cy="14" r="0.8" fill="#b45309"/>
          </svg>
        </div>

        <div class="alert-body">
          <p class="alert-title">Aviso – Novas Regras para Emissão de Notas Fiscais</p>
          <p class="alert-desc">
            A partir de <strong>1º de novembro de 2026</strong>, as microempresas (ME) e empresas de pequeno porte (EPP) optantes pelo <strong>Simples Nacional</strong> deverão emitir suas Notas Fiscais de Serviços Eletrônicas (NFS-e) exclusivamente pelo <strong>Emissor Nacional</strong>, conforme a Resolução CGSN nº 191/2026.
            <br><br>
            Dessa forma, as notas fiscais referentes a serviços com competência a partir de <strong>novembro de 2026</strong> não poderão mais ser emitidas por este sistema municipal.
            <br><br>
            Para continuar emitindo suas notas fiscais, acesse o Portal Nacional da NFS-e:
            <br><br>
            <a href="https://www.gov.br/nfse/pt-br" target="_blank" rel="noopener noreferrer">
              https://www.gov.br/nfse/pt-br
            </a>
            <br><br>
            Recomendamos que os contribuintes realizem seu cadastro e se familiarizem com o Emissor Nacional para evitar transtornos na emissão de notas fiscais.
            <br><br>
            <strong>IMPORTANTE: CONTINUE UTILIZANDO O SISTEMA DA PREFEITURA</strong>
            <br><br>
            Mesmo com a mudança na emissão, nosso sistema municipal continuará oferecendo funcionalidades importantes para a gestão e o acompanhamento das suas informações fiscais:
            <br><br>
            <strong>• Consulta de notas fiscais:</strong> as notas emitidas pelo Emissor Nacional serão importadas automaticamente para o sistema, permitindo visualizar tanto as notas emitidas por sua empresa quanto as notas recebidas de outras empresas.
            <br><br>
            <strong>• Análise do Simples Nacional:</strong> consulte e analise os impostos e as informações das apurações do Simples Nacional, identificando possíveis divergências.
            <br><br>
            <strong>• Notificações fiscais:</strong> consulte e responda às notificações relacionadas às apurações do Simples Nacional diretamente pelo sistema municipal.
            <br><br>
            Portanto, o Emissor Nacional será utilizado para emitir suas notas fiscais, enquanto o sistema da Prefeitura continuará sendo seu ambiente de consulta, acompanhamento e gestão das informações fiscais.
            <br><br>
            <strong>Continue utilizando normalmente o sistema municipal. Ele continua sendo essencial para acompanhar suas notas fiscais e suas obrigações tributárias.</strong>
          </p>
        </div>
        <div class="alert-actions">
          <a href="https://www.gov.br/nfse/pt-br" target="_blank" class="btn-cancelamento">
            Emissor Nacional
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M2.5 6.5h8M7 3l3.5 3.5L7 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
      <div v-show="false" class="alert alert-warning text-dark" role="alert">
        <h4><i class="mdi mdi-alert-circle mr-2"></i> Aviso – Novas Regras para Emissão de Notas Fiscais</h4>
        <p>
          A partir de <strong>1º de novembro de 2026</strong>, as microempresas (ME) e empresas de pequeno porte (EPP) optantes pelo <strong>Simples Nacional</strong> deverão emitir suas Notas Fiscais de Serviços Eletrônicas (NFS-e) exclusivamente pelo <strong>Emissor Nacional</strong>, conforme a Resolução CGSN nº 191/2026.
          <br>
          Dessa forma, as notas fiscais referentes a serviços com competência a partir de <strong>novembro de 2026</strong> não poderão mais ser emitidas por este sistema municipal.
          <br>
          <br>
          Para continuar emitindo suas notas fiscais, acesse o Portal Nacional da NFS-e:
          <br>
          <br>
          <a href="https://www.gov.br/nfse/pt-br" TARGET="_blank">https://www.gov.br/nfse/pt-br</a>
          <br>
          <br>
          Recomendamos que os contribuintes realizem seu cadastro e se familiarizem com o Emissor Nacional para evitar transtornos na emissão de notas fiscais.
        </p>
      </div>
    </div>
    <div v-if="empresa && empresa.eco_codigo" class="row">
      <div v-show="empresa.tab_107situacao !== '1003'" class="col-md-8 col-sm-12">
        <div class="alert alert-danger text-dark" role="alert"><h4><i class="mdi mdi-block-helper mr-2"></i> Empresa
          bloqueada para emissão de Nota Fiscal Eletrônica</h4>
          <p>A empresa possui pendências cadastrais ou fiscais. <br/>
            Procurar o setor tributário ou de finanças do município.</p>
          <p>
            {{ entidade.ent_nome }}<br>
            Endereço: {{ entidade.ent_endereco }}, {{ entidade.ent_numero }}, {{ entidade.ent_bairro }},
            {{ entidade.mun_nome }} - {{ entidade.mun_uf }}<br>
            Telefone: {{ entidade.ent_telefone1 }}<br>
            E-mail: {{ entidade.ent_mail }}<br>
            Site: {{ entidade.ent_site }}<br>
          </p>
        </div>
      </div>
    </div>
    <div v-if="user.is_admin" class="row">
      <div v-show="pedidos_cancelamentos > 0" class="col-sm-12">
        <Transition name="slide-down">
          <div class="alert-cancelamento">
            <div class="alert-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#b45309" stroke-width="1.5"/>
                <path d="M10 6v5" stroke="#b45309" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="10" cy="14" r="0.8" fill="#b45309"/>
              </svg>
            </div>
            <div class="alert-body">
              <p class="alert-title">Atenção — pedidos de cancelamento pendentes</p>
              <p class="alert-desc">
                Há <strong>{{ pedidos_cancelamentos }} {{ pedidos_cancelamentos === 1 ? 'pedido' : 'pedidos' }}</strong>
                de cancelamento aguardando análise e aprovação.
              </p>
            </div>
            <div class="alert-actions">
              <button class="btn-cancelamento" @click="pagePedidos()">
                Ver pedidos
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M2.5 6.5h8M7 3l3.5 3.5L7 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <NotaFiscalDashboard/>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import NotaFiscalDashboard from "@/router/views/dashboards/components/NotaFiscalDashboard.vue";

const {listNotasPedidosCancelamento} = require("../../../api/nfse/nota");
export default {
  page: {
    title: "Painel",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    NotaFiscalDashboard,
    Layout
  },
  data() {
    return {
      title: "Painel",
      items: [
        {
          text: "Painel",
          active: true,
        }
      ],
      httpFichaCadastro: false,
      user: null,
      empresa: null,
      filtros_pedidos_cancelamento: {
        pagina: 1,
        status: '1',
      },
      pedidos_cancelamentos: [],
      duams: [],
      contadores: {
        total_contribuinte: 0,
        total_movimento: 0.00,
        total_nota: 0,
      }
    };
  },
  created() {
    this.user = this.$store.state.auth.currentUser;
    if (this.user && this.user.is_admin) {
      this.listPedidosCancelamentos()
    }
    this.empresa = this.$store.state.auth.currenEmpresa;
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    valor_total_duams: {
      get: function () {
        return this.duams
            .map(d => Number(d.dut_valortributo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    valor_total_atualizado_duams: {
      get: function () {
        return this.duams
            .map(d => Number(d.dut_valortotal))
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    listPedidosCancelamentos() {
      this.httpSend = true;
      listNotasPedidosCancelamento(0, this.filtros_pedidos_cancelamento).then(result => {
        if (result.status) {
          this.pedidos_cancelamentos = result.dados.total;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    pagePedidos() {
      this.$router.push({name: 'admin-gestao-pedidos-cancelamento'});
    },
  },
};
</script>
<style scoped>

/* ─── Alerta cancelamentos ───────────────────────────────── */
.alert-cancelamento {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 1rem 1.25rem;
}

.alert-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.alert-body {
  flex: 1;
  min-width: 0;
}

.alert-title {
  margin: 0 0 3px;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
}

.alert-desc {
  margin: 0;
  font-size: 13px;
  color: #b45309;
  line-height: 1.5;
}

.alert-desc strong {
  font-weight: 600;
  color: #92400e;
}

.alert-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.btn-cancelamento {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f59e0b;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  font-family: 'DM Sans', sans-serif;
  transition: background 0.15s, transform 0.1s;
}

.btn-cancelamento:hover {
  background: #d97706;
}

.btn-cancelamento:active {
  transform: scale(0.97);
}

.btn-fechar-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: background 0.15s;
}

.btn-fechar-alert:hover {
  background: #fde68a;
}
</style>

